import { useEffect, useState } from "react";

// True when the viewport is phone-width (≤ bp px). Updates on resize/rotate.
// Used to stack desktop-only layouts (two-column splits, master-detail) on mobile.
export function useIsMobile(bp = 768) {
  const [m, setM] = useState(() => typeof window !== "undefined" && window.innerWidth <= bp);
  useEffect(() => {
    const on = () => setM(window.innerWidth <= bp);
    window.addEventListener("resize", on);
    return () => window.removeEventListener("resize", on);
  }, [bp]);
  return m;
}
